import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "Badge"
}
const _hoisted_2 = { class: "RefineContentOptionsList" }
const _hoisted_3 = ["data-filter"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tracking = _resolveComponent("Tracking")!
  const _component_DisciplineOption = _resolveComponent("DisciplineOption")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["DisciplineFilterWrapper", { 'is-collapsed': _ctx.collapsed }])
  }, [
    _createElementVNode("header", {
      class: "RefineSectionHeading",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleFilter()))
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "lnr-icons2 FilterIcon" }, null, -1 /* HOISTED */)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "Title" }, "Discipline", -1 /* HOISTED */)),
      (_ctx.filterHintCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.filterHintCount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("i", {
        class: _normalizeClass(["ToggleIcon", [_ctx.collapsed ? 'lnr-chevron-down' : 'lnr-chevron-up']])
      }, null, 2 /* CLASS */)
    ]),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", {
        class: _normalizeClass({ Hidden: !_ctx.isDisciplineSelected })
      }, [
        _createElementVNode("button", {
          class: "ShowMainDisciplines",
          type: "button",
          ref: "allDisciplinesButtonRef",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeSelection()))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "lnr-arrow-left" }, null, -1 /* HOISTED */),
          _createElementVNode("span", null, "All disciplines", -1 /* HOISTED */)
        ]), 512 /* NEED_PATCH */),
        (_ctx.allDisciplinesTrackingData)
          ? (_openBlock(), _createBlock(_component_Tracking, {
              key: 0,
              data: _ctx.allDisciplinesTrackingData
            }, null, 8 /* PROPS */, ["data"]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disciplineFilterOptions, (discipline) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: discipline.id
        }, [
          (_ctx.showDiscipline(discipline.optionValue, discipline.parentIdentity))
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                "data-filter": _ctx.key,
                class: _normalizeClass(["Discipline", {
						'is-active': discipline.optionValue === _ctx.selectedDiscipline,
						Discipline: discipline.parentIdentity === undefined,
						SubDiscipline: discipline.parentIdentity !== undefined,
					}])
              }, [
                _createVNode(_component_DisciplineOption, {
                  discipline: discipline,
                  displayFacets: _ctx.displayFacets,
                  selectedDiscipline: _ctx.selectedDiscipline
                }, null, 8 /* PROPS */, ["discipline", "displayFacets", "selectedDiscipline"])
              ], 10 /* CLASS, PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 2 /* CLASS */))
}